module.exports = __webpack_public_path__ + "static/media/BaileyGillaspyFigure5.34a47fa6.jpg";